import { cn } from "@/lib/cn";
import { STATUT_TONE, type CommandeStatut, type StatusTone } from "@/types/domain";

const TONE_CLASSES: Record<StatusTone, string> = {
  success:
    "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/25",
  attention:
    "bg-amber-100 text-amber-900 border-amber-200 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/25",
  critical:
    "bg-red-100 text-red-800 border-red-200 dark:bg-red-500/10 dark:text-red-400 dark:border-red-500/25",
  info:
    "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/25",
  neutral:
    "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-500/10 dark:text-slate-300 dark:border-slate-500/25",
};

interface StatusBadgeProps {
  status: string;
  tone?: StatusTone;
  className?: string;
  testId?: string;
}

export const StatusBadge = ({ status, tone, className, testId }: StatusBadgeProps) => {
  const resolved = tone ?? STATUT_TONE[status as CommandeStatut] ?? "neutral";
  return (
    <span
      data-testid={testId ?? `status-badge-${status.toLowerCase()}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold tracking-tight",
        TONE_CLASSES[resolved],
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {status.replace(/_/g, " ")}
    </span>
  );
};
